import { useSelector } from 'react-redux';
import { getNativePlatform } from 'redux/modules/nativeApp';

export default function useNativeApp() {
  const platform = useSelector(getNativePlatform);
  return { isNativeApp: Boolean(platform), platform };
}
